module.exports = __webpack_public_path__ + "img/indexkf.56f7e78b.png";